import HorizontalScrollableContainer from "../Common/HorizontalScrollIContainer";
import { NetflixTop10Info } from "../WeddingInfo/WeddingInfo";

interface NetflixTop10Props {
  top10: NetflixTop10Info;
  onOpenImage?: (src: string, title?: string) => void; // ⬅ 콜백
}

const TAP_THRESHOLD_PX = 8;

const NetflixTop10Series: React.FC<NetflixTop10Props> = ({ top10, onOpenImage }) => {
  return (
    <div className="flex flex-col mt-4 text-left mx-4">
      <div className="text-white font-bold">{top10.sectionTitle}</div>

      <HorizontalScrollableContainer>
        <div className="flex space-x-0 mx-4">
          {top10.images.map((imgSrc, index) => {
            let startX = 0;
            let startY = 0;
            let moved = false;

            return (
              <button
                key={index}
                type="button"
                className="relative w-36 focus:outline-none"
                // ✅ 스크롤 중 클릭 방지 (탭만 허용)
                onPointerDown={(e) => {
                  startX = e.clientX;
                  startY = e.clientY;
                  moved = false;
                  // ✅ 포커스 때문에 컨테이너가 '살짝' 움직이는 것 방지
                  (e.currentTarget as HTMLButtonElement).blur();
                }}
                onPointerMove={(e) => {
                  const dx = Math.abs(e.clientX - startX);
                  const dy = Math.abs(e.clientY - startY);
                  if (dx > TAP_THRESHOLD_PX || dy > TAP_THRESHOLD_PX) moved = true;
                }}
                onPointerUp={() => {
                  if (moved) return; // 스와이프(스크롤)였으면 열지 않음
                  onOpenImage?.(imgSrc, "");
                }}
                // ✅ 일부 브라우저에서 mouseDown이 포커스를 만들어 스크롤 튐 -> 예방
                onMouseDown={(e) => e.preventDefault()}
              >
                {/* 순위 넘버 */}
                <div
                  className="absolute -left-8 -bottom-3.5 flex items-center justify-center text-8xl font-extrabold pointer-events-none"
                  style={{ WebkitTextStroke: "2px white", color: "transparent" }}
                >
                  {index + 1}
                </div>

                <img
                  src={imgSrc}
                  alt={`top10-${index + 1}`}
                  className="rounded-[4px] w-24 h-36 scale-105 object-cover"
                  draggable={false}
                />

                {/* 태그 */}
                <div className="absolute -bottom-1 left-6 text-center w-24 justify-center items-center">
                  {index === 0 && (
                    <div>
                      <div className="bg-red-600 text-white text-[7px] w-12">새로운 에피소드</div>
                      <div className="bg-white text-black text-[7px] w-12">지금 시청하기</div>
                    </div>
                  )}
                  {index === 1 && (
                    <div className="bg-red-600 text-white text-[7px] w-12">최신 등록</div>
                  )}
                </div>
              </button>
            );
          })}
        </div>
      </HorizontalScrollableContainer>
    </div>
  );
};

export default NetflixTop10Series;